module.exports = __webpack_public_path__ + "static/media/achievement-grinners-are-winners.dae377c7.svg";